import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import { IoClose } from "react-icons/io5";

// icons (only for the left icon slot your CSS expects)
import {
  FaRegUserCircle,
  FaInstagram,
  FaFacebook,
  FaSchool,
  FaHashtag,
} from "react-icons/fa";
import { FaXTwitter, FaTiktok, FaYoutube } from "react-icons/fa6";
import { FaUserCircle } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";

import { MdSportsSoccer, MdEmail } from "react-icons/md";
import { GiWeight } from "react-icons/gi";
import { MdClass } from "react-icons/md";
import LocationSearch from "../AdminScreens/AccountInformation/LocationSearch";

const SPORTS = [
  "Cross Country",
  "Football",
  "Field Hockey",
  "Soccer",
  "Volleyball",
  "Basketball",
  "Bowling",
  "Fencing",
  "Gymnastics",
  "Ice Hockey",
  "Indoor Track and Field",
  "Rifle",
  "Skiing",
  "Swimming and Diving",
  "Wrestling",
  "Baseball",
  "Beach Volleyball",
  "Golf",
  "Lacrosse",
  "Outdoor Track and Field",
  "Rowing",
  "Softball",
  "Tennis",
  "Water Polo",
];

const CLASSES = ["Freshman", "Sophomore", "Junior", "Senior"];

const CreateAthleteProfile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [additionalPhotos, setAdditionalPhotos] = useState([]);
  const [additionalPreview, setAdditionalPreview] = useState([]);

  const [formData, setFormData] = useState({
    // sport_level: "",
    first_name: "",
    last_name: "",
    email: "",
    sport_name: "",
    school_name: "",
    class_name: "",
    height_feet: "",
    gender_division: "",
    position: "",

    instagram_url: "",
    facebook_url: "",
    x_url: "",
    youtube_url: "",
    tiktok_url: "",
    profile_picture_base64: "",

    hometown: "",
    high_school: "",
    previous_school: "",
    summary_bio: "",
    accolades_awards: "",
    preferred_locations: "",
    interests_hobbies: [],

    // jersey_number: "",
    // height_inches: "",
    // weight: "",
  });

  // const handleAdditionalPhotosChange = async (e) => {
  //   const files = Array.from(e.target.files);

  //   if (files.length + additionalPhotos.length > 10) {
  //     toast.error("You can upload a maximum of 10 photos.");
  //     return;
  //   }

  //   // Convert each file to base64
  //   const convertToBase64 = (file) => {
  //     return new Promise((resolve, reject) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       reader.onload = () => resolve(reader.result);
  //       reader.onerror = (error) => reject(error);
  //     });
  //   };

  //   const base64Images = await Promise.all(
  //     files.map((file) => convertToBase64(file))
  //   );

  //   setAdditionalPhotos((prev) => [...prev, ...base64Images]);
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // prevent negatives for weight/jersey_number
    if (
      (name === "weight" || name === "jersey_number") &&
      value !== "" &&
      Number(value) < 0
    ) {
      return;
    }

    // inches 0–11
    if (name === "height_inches") {
      if (value === "")
        return setFormData((p) => ({ ...p, height_inches: "" }));
      const v = Math.max(0, Math.min(11, Number(value)));
      return setFormData((p) => ({ ...p, height_inches: String(v) }));
    }

    // feet 0–8 (sane bound)
    if (name === "height_feet") {
      if (value === "") return setFormData((p) => ({ ...p, height_feet: "" }));
      const v = Math.max(0, Math.min(8, Number(value)));
      return setFormData((p) => ({ ...p, height_feet: String(v) }));
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // convert to data URL for Postgres BYTEA
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result; // data:image/...;base64,....
      setPreviewSrc(dataUrl);
      setFormData((prev) => ({
        ...prev,
        profile_picture_base64: dataUrl,
      }));
    };
    reader.onerror = () => toast.error("Failed to read image.");
    reader.readAsDataURL(file);
  };

  const heightDisplay = () => {
    const f = formData.height_feet;
    const i = formData.height_inches;
    if (f === "" || i === "") return null;
    return `${Number(f)}' ${Number(i)}"`;
  };
  const validateForm = (formData) => {
    if (!formData.gender_division) {
      toast.error("Please select Division.");
      return false;
    }

    if (!formData.first_name?.trim()) {
      toast.error("Please enter First Name.");
      return false;
    }

    if (!formData.last_name?.trim()) {
      toast.error("Please enter Last Name.");
      return false;
    }

    // Email required
    if (!formData.email?.trim()) {
      toast.error("Please enter Email.");
      return false;
    }

    // Email format
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      toast.error("Please enter a valid Email address.");
      return false;
    }

    // Required dropdowns
    // if (!formData.sport_level) {
    //   toast.error("Please select Sport Level.");
    //   return false;
    // }

    // Required text fields

    if (!formData.sport_name) {
      toast.error("Please select Name of Sport.");
      return false;
    }

    if (!formData.school_name?.trim()) {
      toast.error("Please enter Name of School.");
      return false;
    }

    if (!formData.class_name) {
      toast.error("Please select Class.");
      return false;
    }

    // Height
    if (formData.height_feet === "" || formData.height_inches === "") {
      toast.error("Please enter Height (feet and inches).");
      return false;
    }

    if (formData.hometown?.trim() === "") {
      toast.error("Please enter Hometown.");
      return false;
    }

    if (formData.high_school?.trim() === "") {
      toast.error("Please enter High School.");
      return false;
    }

    if (formData.previous_school?.trim() === "") {
      toast.error("Please enter Previous School.");
      return false;
    }

    if (formData.summary_bio?.trim() === "") {
      toast.error("Please enter Summary Bio.");
      return false;
    }

    if (formData.accolades_awards?.trim() === "") {
      toast.error("Please enter Accolades & Awards.");
      return false;
    }

    // if (formData.preferred_locations?.trim() === "") {
    //   toast.error("Please enter Preferred Locations.");
    //   return false;
    // }

    // if (!formData.interests_hobbies?.length) {
    //   toast.error("Please enter Interests & Hobbies.");
    //   return false;
    // }
    if (!formData.profile_picture_base64) {
      toast.error("Please upload a Profile Photo.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const isValid = validateForm(formData);
    if (!isValid) return;

    const payload = {
      // identity
      first_name: formData.first_name || null,
      last_name: formData.last_name || null,
      email_address: formData.email,
      // sport/school
      sport_name: formData.sport_name || null,
      school_name: formData.school_name || null,
      class_name: formData.class_name || null,
      // radios
      sport_level: formData.sport_level,
      gender_division: formData.gender_division,
      position: formData.position || null,
      jersey_number:
        formData.jersey_number !== "" ? Number(formData.jersey_number) : null,

      // height as formatted text
      height: heightDisplay(), // e.g., 6' 3"  (Ensure DB column is TEXT)

      // weight (lbs)
      weight: formData.weight !== "" ? Number(formData.weight) : null,

      // new fields
      hometown: formData?.hometown,
      high_school: formData?.high_school,
      previous_school: formData?.previous_school,
      summary_bio: formData?.summary_bio,
      accolades_awards: formData?.accolades_awards,
      preferred_locations: [formData?.preferred_locations],
      interests_hobbies: formData?.interests_hobbies,

      // socials
      instagram_url: formData.instagram_url || null,
      facebook_url: formData.facebook_url || null,
      x_url: formData.x_url || null,
      youtube_url: formData.youtube_url || null,
      tiktok_url: formData.tiktok_url || null,

      // image
      profile_picture_base64: formData.profile_picture_base64,
    };

    const url = `${APIUrl()}/v1/create_player_profiles`;
    const options = {
      method: "POST",
      headers: { "X-API-Key": APIUrlToken() },
      data: payload,
      url,
    };

    try {
      setLoading(true);
      await axios(options);
      toast.success("Athlete profile created successfully");

      // Reset
      setFormData({
        gender_division: "",
        first_name: "",
        last_name: "",
        email: "",
        sport_name: "",
        school_name: "",
        class_name: "",
        position: "",
        jersey_number: "",
        height_feet: "",
        height_inches: "",
        weight: "",
        instagram_url: "",
        facebook_url: "",
        x_url: "",
        youtube_url: "",
        tiktok_url: "",
        profile_picture_base64: "",
        hometown: "",
        high_school: "",
        previous_school: "",
        summary_bio: "",
        accolades_awards: "",
        preferred_locations: [],
        interests_hobbies: [],
      });
      setPreviewSrc(null);

      navigate("/");
    } catch (error) {
      toast.error("Error occurred while saving. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helpers to keep alignment identical to Contact Us layout
  const fullWidth = { width: "100%", maxWidth: 720 };
  const row = {
    ...fullWidth,
    display: "flex",
    gap: 16,
    alignItems: "stretch",
    flexWrap: "wrap",
  };
  const col = { flex: 1, minWidth: 280 };
  const removeAdditionalPhoto = (index) => {
    const updated = [...additionalPhotos];
    updated.splice(index, 1);
    setAdditionalPhotos(updated);
  };

  const interestCategories = [
    {
      title: "Entertainment & Pop Culture",
      options: [
        "Movies",
        "TV Shows",
        "Music",
        "Podcasts",
        "Video Games",
        "Anime / Manga",
        "Comics / Graphic Novels",
        "Collectibles",
        "Board Games",
        "Esports",
      ],
    },
    {
      title: "Physical Activities",
      options: [
        "Yoga",
        "Pilates",
        "Gym / Weightlifting",
        "CrossFit",
        "Running / Jogging",
        "Cycling",
        "Hiking",
        "Surfing",
        "Skateboarding",
        "Dance",
        "Cheerleading",
        "Skiing / Snowboarding",
        "Fishing",
        "Hunting",
      ],
    },
    {
      title: "Creative & Artistic",
      options: [
        "Drawing",
        "Painting",
        "Photography",
        "Videography",
        "Graphic Design",
        "Fashion Design",
        "DIY / Crafts",
        "Writing",
        "Poetry",
        "Acting / Theater",
        "Music Production",
        "Singing",
        "Playing Instruments",
        "Makeup Artistry",
      ],
    },
    {
      title: "Travel & Culture",
      options: [
        "Traveling",
        "Road Trips",
        "Camping",
        "Food Exploration / Foodie",
        "Learning Languages",
        "Cultural Experiences",
        "Museums / Art Galleries",
      ],
    },
    {
      title: "Learning & Personal Growth",
      options: [
        "Reading",
        "Studying",
        "Technology",
        "Science",
        "History",
        "Finance / Investing",
        "Business / Entrepreneurship",
        "Personal Development",
        "Podcasts (Educational)",
      ],
    },
    {
      title: "Tech & Digital Life",
      options: [
        "Coding",
        "Web Design",
        "App Development",
        "AI / Machine Learning",
        "Crypto / Blockchain",
        "Tech Gadgets",
        "Smart Home",
        "Digital Art / NFTs",
      ],
    },
    {
      title: "Home & Lifestyle",
      options: [
        "Cooking",
        "Baking",
        "Gardening",
        "Home Improvement",
        "Interior Design",
        "Fitness & Wellness",
        "Meditation",
        "Animals / Pets",
        "Volunteering",
      ],
    },
    {
      title: "Outdoor & Adventure",
      options: [
        "Boating",
        "Sailing",
        "Scuba Diving",
        "Snorkeling",
        "Rock Climbing",
        "ATV / Off-roading",
        "Stargazing",
        "Nature Photography",
      ],
    },
    {
      title: "Professional & Career Interests",
      options: [
        "Marketing",
        "Social Media",
        "Leadership",
        "Networking",
        "Real Estate",
        "Coaching / Mentorship",
        "Event Planning",
      ],
    },
  ];
  const handleInterestCheckbox = (value) => {
    setFormData((prev) => {
      const updated = prev.interests_hobbies?.includes(value)
        ? prev.interests_hobbies.filter((item) => item !== value)
        : [...prev.interests_hobbies, value];

      return { ...prev, interests_hobbies: updated };
    });
  };

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-changepass">
          <h3>Create your Athlete NIL Profile</h3>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Radios Row: clearly separated groups in one row */}
            <div className="input-section-changepass cu-nil" style={row}>
              {/* Sport Level box */}
              {/* <div className="input-group-changepass" style={col}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
                  Select Sport Level <span style={{ color: 'red' }}>*</span>
                </label>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <input
                      type="radio"
                      name="sport_level"
                      value="College Sports"
                      checked={formData.sport_level === 'College Sports'}
                      onChange={handleChange}
                    />
                    College Sports
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <input
                      type="radio"
                      name="sport_level"
                      value="High School Sports"
                      checked={formData.sport_level === 'High School Sports'}
                      onChange={handleChange}
                    />
                    High School Sports
                  </label>
                </div>
              </div> */}

              {/* Division box */}
              <div className="input-group-changepass" style={col}>
                <label
                  style={{ display: "block", marginBottom: 6, fontWeight: 600 }}
                >
                  Select Division <span style={{ color: "red" }}>*</span>
                </label>
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <input
                      type="radio"
                      name="gender_division"
                      value="Men"
                      checked={formData.gender_division === "Men"}
                      onChange={handleChange}
                    />
                    Men
                  </label>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <input
                      type="radio"
                      name="gender_division"
                      value="Women"
                      checked={formData.gender_division === "Women"}
                      onChange={handleChange}
                    />
                    Women
                  </label>
                </div>
              </div>
            </div>

            {/* First Name */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="First Name *"
                  className="form-control-changepass-user"
                  value={formData.first_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* Last Name */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Last Name *"
                  className="form-control-changepass-user"
                  value={formData.last_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>
            {/* Email (optional) */}
            <div
              className="input-section-changepass cu-nil"
              style={{ width: "100%", maxWidth: 720 }}
            >
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <MdEmail />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  className="form-control-changepass-user"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* Name of Sport: SELECT (like Class) */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <MdSportsSoccer />
                </div>
                <select
                  name="sport_name"
                  className="form-control-changepass-user"
                  value={formData.sport_name}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                >
                  <option value="" disabled>
                    Select Name of Sport *
                  </option>
                  {SPORTS.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Name of School */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaSchool />
                </div>
                <input
                  type="text"
                  name="school_name"
                  placeholder="Name of School *"
                  className="form-control-changepass-user"
                  value={formData.school_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* Class: dropdown */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <MdClass />
                </div>
                <select
                  name="class_name"
                  className="form-control-changepass-user"
                  value={formData.class_name}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                >
                  <option value="" disabled>
                    Select Class *
                  </option>
                  {CLASSES.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row: Position | Jersey Number */}
            <div className="input-section-changepass cu-nil" style={row}>
              <div className="input-group-changepass" style={col}>
                <div className="input-icon-changepass">
                  <MdSportsSoccer />
                </div>
                <input
                  type="text"
                  name="position"
                  placeholder="Position (if applicable)"
                  className="form-control-changepass-user"
                  value={formData.position}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              <div className="input-group-changepass" style={col}>
                <div className="input-icon-changepass">
                  <FaHashtag />
                </div>
                <input
                  type="number"
                  name="jersey_number"
                  placeholder="Jersey Number (if applicable)"
                  min={0}
                  className="form-control-changepass-user"
                  value={formData.jersey_number}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* Height (single box w/ ft & in) | Weight (lbs) */}
            <div className="input-section-changepass cu-nil" style={row}>
              {/* Height combined */}
              <div className="input-group-changepass" style={col}>
                <label
                  style={{ display: "block", marginBottom: 6, fontWeight: 600 }}
                >
                  Height (ft/in) <span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: 8, width: "100%" }}>
                  <input
                    type="number"
                    name="height_feet"
                    placeholder="ft"
                    min={0}
                    max={8}
                    className="form-control-changepass-user"
                    value={formData.height_feet}
                    onChange={handleChange}
                    autoComplete="off"
                    style={{ flex: 1 }}
                  />
                  <input
                    type="number"
                    name="height_inches"
                    placeholder="in"
                    min={0}
                    max={11}
                    className="form-control-changepass-user"
                    value={formData.height_inches}
                    onChange={handleChange}
                    autoComplete="off"
                    style={{ flex: 1 }}
                  />
                </div>
              </div>

              {/* Weight lbs */}
              <div className="input-group-changepass" style={col}>
                <div className="input-icon-changepass">
                  <GiWeight />
                </div>
                <input
                  type="number"
                  name="weight"
                  placeholder="Weight (lbs, if applicable)"
                  min={0}
                  className="form-control-changepass-user"
                  value={formData.weight}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                {/* <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div> */}
                {/* <input
                  type="text"
                  name="hometown"
                  placeholder="Hometown *"
                  className="form-control-changepass-user"
                  value={formData.hometown}
                  onChange={handleChange}
                  autoComplete="off"
                /> */}
                 <LocationSearch
              value={formData.hometown}
              // disabled={disableEdit === ""}
              onSelect={(loc) =>
                setFormData((prev) => ({ ...prev, hometown: loc }))
              }
              placeholder={"Birthplace"}
            />
              </div>
            </div>
           
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="high_school"
                  placeholder="High School *"
                  className="form-control-changepass-user"
                  value={formData.high_school}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="previous_school"
                  placeholder="Previous School *"
                  className="form-control-changepass-user"
                  value={formData.previous_school}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="summary_bio"
                  placeholder="Summary (Bio) *"
                  className="form-control-changepass-user"
                  value={formData.summary_bio}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="accolades_awards"
                  placeholder="Accolades & Awards *"
                  className="form-control-changepass-user"
                  value={formData.accolades_awards}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="preferred_locations"
                  placeholder="Preferred Locations: *"
                  className="form-control-changepass-user"
                  value={formData.preferred_locations}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div> */}

            {/* <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="interests_hobbies"
                  placeholder="Interests / Hobbies *"
                  className="form-control-changepass-user"
                  value={formData.interests_hobbies}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div> */}
            {/* <h3 className="section-title-accountInfo">Interests / Hobbies</h3>
            <div className="interests-section">
              {interestCategories.map((cat, idx) => (
                <div key={idx} className="interest-category">
                  <h4 className="interest-heading">{cat.title}</h4>

                  <div className="interest-grid">
                    {cat.options.map((option, i) => (
                      <label key={i} className="interest-item">
                        <input
                          type="checkbox"
                          checked={formData.interests_hobbies?.includes(option)}
                          onChange={() => handleInterestCheckbox(option)}
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div> */}

            {/* Social links */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaInstagram />
                </div>
                <input
                  type="text"
                  name="instagram_url"
                  placeholder="Instagram Profile Link"
                  className="form-control-changepass-user"
                  value={formData.instagram_url}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaFacebook />
                </div>
                <input
                  type="text"
                  name="facebook_url"
                  placeholder="Facebook Profile Link"
                  className="form-control-changepass-user"
                  value={formData.facebook_url}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaXTwitter />
                </div>
                <input
                  type="text"
                  name="x_url"
                  placeholder="X Profile Link"
                  className="form-control-changepass-user"
                  value={formData.x_url}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaYoutube />
                </div>
                <input
                  type="text"
                  name="youtube_url"
                  placeholder="YouTube Profile Link"
                  className="form-control-changepass-user"
                  value={formData.youtube_url}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaTiktok />
                </div>
                <input
                  type="text"
                  name="tiktok_url"
                  placeholder="TikTok Profile Link"
                  className="form-control-changepass-user"
                  value={formData.tiktok_url}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* Upload Photo (REQUIRED) */}
            <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaCamera />
                </div>

                <input
                  type="file"
                  accept="image/*"
                  id="profilePicInput"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />

                <label
                  htmlFor="profilePicInput"
                  className="form-control-changepass-user"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {previewSrc
                    ? "Change Profile Picture"
                    : "Upload Profile Picture"}
                </label>
              </div>

              {previewSrc && (
                <div style={{ marginTop: 8 }}>
                  <img
                    src={previewSrc}
                    alt="Preview"
                    style={{ maxHeight: 120, borderRadius: 8 }}
                  />
                </div>
              )}
            </div>

            {/* <div className="input-section-changepass cu-nil" style={fullWidth}>
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaCamera />
                </div>

                <input
                  type="file"
                  accept="image/*"
                  id="additionalPhotosInput"
                  style={{ display: "none" }}
                  multiple
                  onChange={handleAdditionalPhotosChange} 
                />

                <label
                  htmlFor="additionalPhotosInput"
                  className="form-control-changepass-user"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Upload Additional Photos
                </label>
              </div>

              {additionalPhotos?.length > 0 && (
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  {additionalPhotos.map((img, i) => (
                    <div
                      key={i}
                      style={{
                        position: "relative",
                        width: 80,
                        height: 80,
                      }}
                    >
                      <IoClose
                        onClick={() => removeAdditionalPhoto(i)}
                        style={{
                          position: "absolute",
                          top: -6,
                          right: -6,
                          background: "#fff",
                          borderRadius: "50%",
                          fontSize: 20,
                          cursor: "pointer",
                          boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
                          zIndex: 10,
                        }}
                      />

                      <img
                        src={img}
                        alt={`Additional ${i}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div> */}

            {/* Submit */}
            <div className="button-section-changepass-user">
              <button onClick={handleSubmit} disabled={loading}>
                {loading ? "Submitting..." : "Submit Profile"}
              </button>
            </div>

            <p style={{ marginTop: 12, fontSize: 12, opacity: 0.8 }}>
              * If any non‑required fields are left blank, that row or section
              will not be displayed.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CreateAthleteProfile;
